<template>
  <v-dialog v-model="dialog" width="1200" :persistent="true">
    <v-card>
      <v-toolbar card dark color="primary">
        <v-toolbar-title>
          <v-layout row wrap align-end>
            <v-flex>
              {{ productName }}
              <span
                class="body-1"
                v-for="(productCategoryNames, key) in productCategoryName"
                :key="productCategoryNames"
              >
                {{ productCategoryNames }}
                <v-icon small v-if="key < productCategoryName.length - 1">chevron_right</v-icon>
              </span>
            </v-flex>
          </v-layout>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark small @click="close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <nutrients-details ref="nutrientsDetails"/>
        <v-layout row pt-2>
          <v-flex xs12>
            <strong>{{ 'app.pages.products_weights' | trans }}:</strong>
            <v-chip color="green" text-color="white" v-for="weight in fifthColumn" :key="weight.id">
              {{ weight.name }}: <strong>{{ weight.value }}g</strong>
            </v-chip>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12>
            <strong>{{ 'app.pages.products.seasonality' | trans }}:</strong>
            <v-chip color="green" text-color="white" v-for="month in sixthColumn" :key="month.name">
              {{ month.name }}
            </v-chip>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12>
            <strong>{{ 'app.tags.tags' | trans }}:</strong>
            <span v-if="tags.length === 0">{{ 'app.no_data' | trans }}</span>
            <v-chip color="green" text-color="white" v-for="tag in tags" :key="tag.uuid">
              {{ tag.name }}
            </v-chip>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12>
            <strong>{{ 'app.pages.products.type' | trans }}:</strong> {{ type }}
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="close">
          {{ 'app.close' | trans }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import ProductInitialDataService from '../../services/ProductInitialDataService';
import { trans } from '../../app';
import { helpers } from '../../helpers';

export default {
  data: function () {
    return {
      dialog: false,
      search: null,
      productName: null,
      productCategoryName: null,
      type: null,
      tags: [],
      columns: {
        fifthColumn: [],
        sixthColumn: [],
      },
      initialData: {
        fifthColumn: [],
        sixthColumn: [],
      },
    };
  },
  async mounted() {
    const initialDataService = new ProductInitialDataService();
    const { data } = await initialDataService.fetch();
    this.$refs.nutrientsDetails.init(data)
    this.columns.fifthColumn = Object.values(data[5]).map((weight) => ({
      name: weight.name,
      id: weight.id,
      value: '',
    }));

    this.initialData.fifthColumn = helpers.deepClone(this.columns.fifthColumn);
  },
  methods: {
    async open(productId) {
      this.dialog = true;
      const { data } = await axios.get(`/v2/products/${productId}`);
      const product = data.data;

      this.productName = product.name;
      this.productCategoryName = product.category.full_category;
      this.type = this.resolveType(product);
      this.tags = product.tags;

      this.$refs.nutrientsDetails.load(product.nutrients);

      this.columns.fifthColumn.forEach((weight) => {
        const weightWithValue = product.weights.find((weightWithValue) => weightWithValue.id === weight.id);
        if (weightWithValue !== undefined) {
          weight.value = weightWithValue.weight;
        }
      });
      this.columns.sixthColumn = product.seasons.map((season) => ({ name: this.getMonths()[season] }));
    },
    close() {
      this.dialog = false;
      this.search = null;
      this.productName = null;
      this.productCategoryName = null;
      this.$refs.nutrientsDetails.unload();
      this.columns.fifthColumn = helpers.deepClone(this.initialData.fifthColumn);
    },
    getMonths() {
      return {
        1: trans('app.months.january'),
        4: trans('app.months.april'),
        7: trans('app.months.july'),
        10: trans('app.months.october'),
        2: trans('app.months.february'),
        5: trans('app.months.may'),
        8: trans('app.months.august'),
        11: trans('app.months.november'),
        3: trans('app.months.march'),
        6: trans('app.months.june'),
        9: trans('app.months.september'),
        12: trans('app.months.december'),
      };
    },
    resolveType(product) {
      if (product.is_shared) {
        return trans('app.products.create_modal.shared_product');
      }
      if (product.is_system) {
        return trans('app.products.create_modal.system_product');
      }

      return trans('app.products.create_modal.own_product');
    },
  },
  computed: {
    fifthColumn: function () {
      return this.columns.fifthColumn.filter((weight) => !!weight.value);
    },
    sixthColumn: function () {
      return this.columns.sixthColumn.length === 12
        ? [
            {
              name: trans('app.products.create_modal.whole_year'),
            },
          ]
        : this.columns.sixthColumn;
    },
  },
};
</script>

<style scoped>
.w60 {
  width: 60%;
}
>>> .v-list__tile:not(.v-list__tile--avatar) {
  height: 32px;
}

>>> .v-list__tile:hover {
  background: #eee;
}

.v-dialog__content {
  z-index: 1030 !important;
}
</style>
